import React from "react";

const Dropdown = ({ items, onSelect }) => {
  const handleSelect = (event) => {
    const selectedValue = event.target.value;
    onSelect(selectedValue);
  };
  return (
    <div>
      {items?.length != 0 ? (
        <>
          <select
            onClick={handleSelect}
            className="px-1 my-2 bg-[#434242] border-white border-2 text-white py-2"
          >
            {items?.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        </>
      ) : (
        <>
          <>
            <p className="text-white">Create a department</p>
          </>
        </>
      )}
    </div>
  );
};

export default Dropdown;
